import React, { useEffect } from "react";

const GoogleTranslate = () => {
    useEffect(() => {
        const googleTranslateElementInit = () => {
            if (window.google && window.google.translate && window.google.translate.TranslateElement) {
                new window.google.translate.TranslateElement(
                    {
                        pageLanguage: "en",
                        autoDisplay: false,
                        includedLanguages: "en,hi,as,bn,gu,kn,ml,mni,mr,or,pa,ta,te,ur",
                    },
                    "google_translate_element"
                );
            } else {
                console.error('Google Translate API is not available.');
            }
        };

        googleTranslateElementInit();
    }, []);

    return (
        <div id="google_translate_element" ></div>
    );
};

export default GoogleTranslate;
